












import Vue from 'vue'
import { hasUnaddressedLiveAlert, isInAnyRoom, isInOwnRoom } from '@/utils/patients'
import MapAlert from '@/components/map/MapAlert.vue'
import { getPatientEventLastAddressedKey, isEventAddressed } from '@/jsonapi/PatientWithEvents'

export default Vue.extend({
  components: { MapAlert },
  props: {
    patient: {
      type: Object,
      required: true,
    },
    forSharedRoom: {
      type: Boolean,
      default: false,
    },
    searched: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      eventLastAddressedKey: null,
      mapAlertPositionClass: 'right',
    }
  },

  computed: {
    wrapperClassList() {
      let style = this.shouldEnlargeThisIcon() ? 'enlarged-location-icon' : 'normal-location-icon'
      let classes = ['location-icon', 'ma-0', style]
      if (!isInAnyRoom(this.patient)) {
        // classes.push('unknown-location-icon') // removed question mark March 14 / 2021
        classes.push('out-location-icon')
      } else if (!isInOwnRoom(this.patient)) {
        classes.push('shared-room-icon')
      }
      return classes
    },

    liveEvent() {
      return this.patient && this.patient.liveEvents && this.patient.liveEvents[0]
    },

    enlargedIconFontSize() {
      if (!this.patient || !this.patient.roomNumber) {
        return '2em'
      }
      switch (this.patient.roomNumber.length) {
        case 1:
          return '1.4em'
        case 2:
          return '1.4em'
        case 3:
          return '1.2em'
        case 4:
          return '1.0em'
        case 5:
          return '0.8em'
      }
      return '1em'
    },
    locationTextTop() {
      let pos = 35
      if (!this.patient || !this.patient.roomNumber) {
        return pos + 'px'
      }
      switch (this.patient.roomNumber.length) {
        case 1:
        case 2:
          pos = 38
          break
        case 3:
          pos = 38
          break
        case 4:
          pos = 38
          break
        case 5:
          pos = 43
          break
      }
      if (this.forSharedRoom) {
        pos += 5
      }
      return pos + 'px'
    },
    locationTextPaddingRight() {
      let paddingRight = 10

      if (!this.isForOwnRoom() || this.isInThisRoom() || !this.patient || !this.patient.roomNumber) {
        return paddingRight + 'px'
      }

      switch (this.patient.roomNumber.length) {
        case 1:
          paddingRight += 6
          break
        case 2:
          paddingRight += 5
      }

      return paddingRight + 'px'
    },
    wrapperCssVars() {
      return {
        '--width': (this.shouldEnlargeThisIcon() ? 64 : 16) + 'px',
        '--height': this.shouldEnlargeThisIcon() ? '150px' : '24px',

        '--indicator-left':
          this.patient && this.shouldEnlargeThisIcon()
            ? isInAnyRoom(this.patient)
              ? '-15px'
              : '-2px'
            : isInAnyRoom(this.patient)
            ? '7px'
            : '0px',

        '--location-text-top': this.locationTextTop,
        '--enlarged-icon-font-size': this.enlargedIconFontSize,
        '--location-text-padding-right': this.locationTextPaddingRight,
      }
    },

    locationIcon() {
      let style = this.shouldEnlargeThisIcon() ? 'large' : 'small'
      let status = this.hasUnaddressedLiveAlert() ? 'critical' : 'good'

      let loc = this.isInThisRoom() ? 'here' : 'out'

      if (this.patient && !isInAnyRoom(this.patient)) {
        style = 'small' // no large-unknown icon yet
      }
      return require('@/assets/location-icons/' + loc + '-' + status + '/' + style + '.svg')
    },
  },
  mounted() {
    if (this.liveEvent && isEventAddressed(this.patient.id, this.liveEvent)) {
      this.eventLastAddressedKey = getPatientEventLastAddressedKey(this.patient.id, this.liveEvent)
    }
    this.mapAlertPositionClass = this.loadMapAlertPositionClass()
  },
  methods: {
    isForOwnRoom: function() {
      return !this.forSharedRoom
    },
    isLocationUnknown: function() {
      return !isInAnyRoom(this.patient)
    },
    shouldEnlargeThisIcon: function() {
      return (
        (this.searched || this.hasUnaddressedLiveAlert()) &&
        (this.isInThisRoom() || (this.isForOwnRoom() && this.isLocationUnknown()))
      )
    },
    isInThisRoom: function() {
      if (this.forSharedRoom) {
        return true
      }
      return isInOwnRoom(this.patient)
    },

    hasUnaddressedLiveAlert: function() {
      if (this.eventLastAddressedKey && this.liveEvent) {
        let eventKey = getPatientEventLastAddressedKey(this.patient.id, this.liveEvent)
        if (eventKey == this.eventLastAddressedKey) {
          return false // the most recent event is already addressed (as per this component's data)
        }
      }
      // load from localstorage now...
      return this.liveEvent && hasUnaddressedLiveAlert(this.patient.id, this.liveEvent)
    },
    alertAddressed: function() {
      this.eventLastAddressedKey = getPatientEventLastAddressedKey(this.patient.id, this.liveEvent)
    },

    getMapRect() {
      return document.getElementById('patient-map').getBoundingClientRect()
    },

    offsetLeftInMap() {
      let thisLeft = this.$el.getBoundingClientRect().left
      let patientMapLeft = this.getMapRect().left
      return (thisLeft - patientMapLeft) * 1.25 // because LBMF is scale 0.8
    },

    loadMapAlertPositionClass() {
      console.log('offset left in map (' + this.patient.roomNumber + '): ' + this.offsetLeftInMap())
      if (this.offsetLeftInMap() > 400) {
        return 'left'
      } else {
        return 'right'
      }
    },
  },
})
